'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FileField = function (_AbstractField) {
    (0, _inherits3.default)(FileField, _AbstractField);

    function FileField() {
        (0, _classCallCheck3.default)(this, FileField);
        return (0, _possibleConstructorReturn3.default)(this, (FileField.__proto__ || (0, _getPrototypeOf2.default)(FileField)).apply(this, arguments));
    }

    (0, _createClass3.default)(FileField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                addonsBefore = _props.addonsBefore,
                addonsAfter = _props.addonsAfter,
                _onChange = _props.onChange,
                _onBlur = _props.onBlur,
                value = _props.value,
                props = (0, _objectWithoutProperties3.default)(_props, ['addonsBefore', 'addonsAfter', 'onChange', 'onBlur', 'value']);


            var field = _react2.default.createElement(_reactstrap.Input, (0, _extends3.default)({
                type: 'file',
                onChange: function onChange(e) {
                    return _onChange(e.target.files[0]);
                },
                onBlur: function onBlur(e) {
                    return _onBlur(e.target.files[0]);
                }
            }, props));

            return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        }
    }]);
    return FileField;
}(_AbstractField3.default);

exports.default = FileField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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